"use strict";
exports.__esModule = true;
exports.toVideo = void 0;
var utils_1 = require("@lglp/utils");
var video_1 = require("../../types/partials/video");
var fields_1 = require("../fields");
var toVideo = function (data, logger) {
    var prismicVideo = utils_1.unprefix('video', data);
    if (prismicVideo) {
        var url = logger.required(fields_1.toWebLink(prismicVideo.url, logger));
        if (!url) {
            return undefined;
        }
        return utils_1.compact({
            title: logger.required(fields_1.toText(prismicVideo.title)),
            url: url,
            type: logger.toConstValue(prismicVideo.kind, {
                Youtube: video_1.VideoType.Youtube,
                Libcast: video_1.VideoType.Libcast,
                Autre: video_1.VideoType.Other
            }) || video_1.VideoType.Youtube,
            transcription: fields_1.toRichText(prismicVideo.transcription, logger)
        });
    }
};
exports.toVideo = toVideo;
//# sourceMappingURL=video.js.map